import {createAction, handleActions} from 'redux-actions';
import {call, put, takeLatest} from 'redux-saga/effects';

import {createRequestActionTypes} from '../../api/createRequestSaga';
import * as ideaAPI from '../../api/idea/list';
import {finishLoading, startLoading} from '../loading';

const INITIALIZE = 'idea/INITIALIZE';
const INITIALIZE_DETAIL = 'idea/INITIALIZE_DETAIL';
const [READ_IDEA_LIST, READ_IDEA_LIST_SUCCESS, READ_IDEA_LIST_FAILURE] = createRequestActionTypes('idea/READ_IDEA_LIST');
const [READ_IDEA_YEARS, READ_IDEA_YEARS_SUCCESS, READ_IDEA_YEARS_FAILURE] = createRequestActionTypes('idea/READ_IDEA_YEARS');
const [READ_IDEA_DETAIL, READ_IDEA_DETAIL_SUCCESS, READ_IDEA_DETAIL_FAILURE] = createRequestActionTypes('idea/READ_IDEA_DETAIL');

export const initialize = createAction(INITIALIZE);
export const initializeDetail = createAction(INITIALIZE_DETAIL);

export const readIdeaList = createAction(
    READ_IDEA_LIST,
    ({ year, category, status, page, pagesize, keyword } = {}) => ({ year, category, status, page, pagesize, keyword })
);

export const readIdeaYears = createAction(READ_IDEA_YEARS);

export const readIdeaDetail = createAction(
    READ_IDEA_DETAIL,
    ({ ideaId } = {}) => ({ ideaId })
);

function* readIdeaListSaga(action) {
    yield put(startLoading(READ_IDEA_LIST));
    try {
        const response = yield call(ideaAPI.readIdeaList, action.payload);
        if (response.data.code === 200) {
            yield put({
                type: READ_IDEA_LIST_SUCCESS,
                payload: response.data
            });
        } else {
            yield put({
                type: READ_IDEA_LIST_FAILURE,
                payload: response.data,
                error: true
            });
        }
    } catch (e) {
        yield put({
            type: READ_IDEA_LIST_FAILURE,
            payload: e,
            error: true
        });
    } finally {
        yield put(finishLoading(READ_IDEA_LIST));
    }
}

function* readIdeaYearsSaga() {
    yield put(startLoading(READ_IDEA_YEARS));
    try {
        const response = yield call(ideaAPI.readIdeaYears);
        if (response.data.code === 200) {
            yield put({
                type: READ_IDEA_YEARS_SUCCESS,
                payload: response.data
            });
        } else {
            yield put({
                type: READ_IDEA_YEARS_FAILURE,
                payload: response.data,
                error: true
            });
        }
    } catch (e) {
        yield put({
            type: READ_IDEA_YEARS_FAILURE,
            payload: e,
            error: true
        });
    } finally {
        yield put(finishLoading(READ_IDEA_YEARS));
    }
}

function* readIdeaDetailSaga(action) {
    yield put(startLoading(READ_IDEA_DETAIL));
    try {
        const response = yield call(ideaAPI.readIdeaDetail, action.payload);
        if (response.data.code === 200) {
            yield put({
                type: READ_IDEA_DETAIL_SUCCESS,
                payload: response.data
            });
        } else {
            yield put({
                type: READ_IDEA_DETAIL_FAILURE,
                payload: response.data,
                error: true
            });
        }
    } catch (e) {
        yield put({
            type: READ_IDEA_DETAIL_FAILURE,
            payload: { status: e?.response?.status, detail: e?.response?.data?.detail, raw: e?.message },
            error: true
        });
    } finally {
        yield put(finishLoading(READ_IDEA_DETAIL));
    }
}

export function* ideaSaga() {
    yield takeLatest(READ_IDEA_LIST, readIdeaListSaga);
    yield takeLatest(READ_IDEA_YEARS, readIdeaYearsSaga);
    yield takeLatest(READ_IDEA_DETAIL, readIdeaDetailSaga);
}

const initialState = {
    listResponse: null,
    listErrorResponse: null,
    yearsResponse: null,
    yearsErrorResponse: null,
    detailResponse: null,
    detailErrorResponse: null
};

const idea = handleActions(
    {
        [INITIALIZE]: () => initialState,
        [INITIALIZE_DETAIL]: (state) => ({
            ...state,
            detailResponse: null,
            detailErrorResponse: null
        }),
        [READ_IDEA_LIST_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            listResponse: data.data,
            listErrorResponse: null
        }),
        [READ_IDEA_LIST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            listResponse: null,
            listErrorResponse: error
        }),
        [READ_IDEA_YEARS_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            yearsResponse: data.data,
            yearsErrorResponse: null
        }),
        [READ_IDEA_YEARS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            yearsResponse: null,
            yearsErrorResponse: error
        }),
        [READ_IDEA_DETAIL_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            detailResponse: data.data,
            detailErrorResponse: null
        }),
        [READ_IDEA_DETAIL_FAILURE]: (state, { payload: error }) => ({
            ...state,
            detailResponse: null,
            detailErrorResponse: error
        })
    },
    initialState
);

export default idea;
